import { QueryClient } from "@tanstack/react-query";

/**
 * Single QueryClient mounted at the root. Tuned to surface auth/tenant
 * errors immediately rather than retrying (Bearer token failures are not
 * transient — they need a real re-login).
 */
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: false,
      staleTime: 5_000,
      refetchOnWindowFocus: false,
    },
  },
});
